import { withProps } from 'recompose';
import MatrixQuestion from './MatrixQuestion';
import MatrixRadioGroupField from './matrixTable/taker/MatrixRadioGroupField';

export default withProps({
  inputRowField: MatrixRadioGroupField,
})(MatrixQuestion);
